// extracted by mini-css-extract-plugin
export default {"root":"root--rahR5","bold":"bold--otKUb"};